import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mkqgf4yzct: FaireBrandEntity = {
  token: "b_mkqgf4yzct",
  type: "brand",
  name: "HarperCollins Focus",
  avatarUrl:
    "https://cdn.faire.com/fastly/7d95e1b553a4eecf930b0a09074be2b2ae9889acab96e78cb490d38ac1027cfd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/589a86a8f8f53fb7af8fb3da402a8a4a2932739ce623a770a33e5bd5d3d26055.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7d95e1b553a4eecf930b0a09074be2b2ae9889acab96e78cb490d38ac1027cfd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/589a86a8f8f53fb7af8fb3da402a8a4a2932739ce623a770a33e5bd5d3d26055.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "HarperCollins Focus owns and operates a collection of publishing imprints, that enlighten and empower readers to transform their hearts and minds, connecting through story, advice, mentorship and community. The company’s mission is to inspire the world with content that equips people to lead lives of significance, integrity and purpose. The company also operates HarperCollins Leadership Essentials, a destination online community dedicated to accelerating personal and professional development. The company is based in Nashville, TN.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:12.075Z",
    importedBy: "entity-db-cli",
  },
};
